import { useCallback, useEffect, useRef, useState } from 'react';

// Janela de dedup por phone (evita 2 toasts do mesmo contato em rajada)
const DEDUPE_WINDOW_MS = 5000;
// Janela de agregacao: se chegarem N transferencias em ate 8s, agrupa numa
// unica notificacao "N contatos transferidos". Evita flood quando ha disparo
// em massa (ex: 30 contatos virando handoff num burst de teste).
const BATCH_WINDOW_MS = 8000;

export default function useContactTransferredNotifications() {
  // Batch atualmente exibido na UI: { batch: [payload...], firstAt }
  const [current, setCurrent] = useState(null);
  // Pendentes acumulando ate fechar a janela
  const pendingRef = useRef([]);
  const recentRef = useRef(new Map());
  const timerRef = useRef(null);

  const flush = useCallback(() => {
    timerRef.current = null;
    if (pendingRef.current.length === 0) return;
    const batch = pendingRef.current;
    pendingRef.current = [];
    // Se nao ha nada exibido, publica agora. Se ja existe um batch ativo,
    // empilha no proprio current (concatena) para nao perder transferencias
    // que chegaram enquanto o user ainda nao dismissou.
    setCurrent((prev) => {
      if (!prev) {
        return { batch, firstAt: batch[0]._ts };
      }
      return { batch: [...prev.batch, ...batch], firstAt: prev.firstAt };
    });
  }, []);

  const enqueue = useCallback((payload) => {
    if (!payload?.contact_phone) return;
    const phone = payload.contact_phone;
    const now = Date.now();
    const last = recentRef.current.get(phone);
    if (last && now - last < DEDUPE_WINDOW_MS) return;
    recentRef.current.set(phone, now);

    pendingRef.current.push({ ...payload, _ts: now });

    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(flush, BATCH_WINDOW_MS);
  }, [flush]);

  const dismissCurrent = useCallback(() => {
    setCurrent(null);
  }, []);

  // Cleanup
  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return { current, enqueue, dismissCurrent };
}
